var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"is-size-5"},[_vm._v("Area")]),_c('hr'),(_vm.agentEvacuation.length > 0)?_c('b-columns',[_c('b-column',[_c('b-table',{attrs:{"data":_vm.agentEvacuation,"columns":_vm.columns}})],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }